var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _line, _line2, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _g, _path22, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurely(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 200,
    viewBox: "0 0 204 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.0064 58.5918H52.3115C44.0595 58.5918 37.3699 65.3925 37.3699 73.7816V73.7836C37.3699 82.1727 44.0595 88.9734 52.3115 88.9734H93.0064C101.258 88.9734 107.948 82.1727 107.948 73.7836V73.7816C107.948 65.3925 101.258 58.5918 93.0064 58.5918Z",
    fill: "#E6EFF6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M188.597 112.174H140.918C134.344 112.174 129.015 118.975 129.015 127.364V127.366C129.015 135.755 134.344 142.555 140.918 142.555H188.597C195.171 142.555 200.5 135.755 200.5 127.366V127.364C200.5 118.975 195.171 112.174 188.597 112.174Z",
    fill: "#E6EFF6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3093 147.526H49.4735C42.2068 147.526 36.3159 153.709 36.3159 161.335V161.337C36.3159 168.964 42.2068 175.146 49.4735 175.146H85.3093C92.576 175.146 98.4669 168.964 98.4669 161.337V161.335C98.4669 153.709 92.576 147.526 85.3093 147.526Z",
    fill: "#E6EFF6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M155.36 26H119.524C112.257 26 106.366 32.1825 106.366 39.8089V39.8107C106.366 47.4372 112.257 53.6197 119.524 53.6197H155.36C162.626 53.6197 168.517 47.4372 168.517 39.8107V39.8089C168.517 32.1825 162.626 26 155.36 26Z",
    fill: "#E6EFF6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.964 100.572L13.6576 100.572C6.39085 100.572 0.5 106.755 0.5 114.381V114.383C0.5 122.009 6.39085 128.192 13.6576 128.192L58.964 128.192C66.2308 128.192 72.1216 122.009 72.1216 114.383V114.381C72.1216 106.755 66.2308 100.572 58.964 100.572Z",
    fill: "#E6EFF6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M196.658 47.8353L114.601 47.4384C110.823 47.4201 107.754 50.4682 107.746 54.2464L107.513 169.867C107.506 173.645 110.562 176.723 114.341 176.741L196.398 177.138C200.176 177.156 203.245 174.108 203.253 170.33L203.486 54.7095C203.493 50.9313 200.437 47.8536 196.658 47.8353Z",
    fill: "#BFD6E8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M120.43 106.212C120.43 103.693 122.472 101.651 124.991 101.651L186.561 101.651C189.08 101.651 191.122 103.693 191.122 106.212L191.122 142.698C191.122 145.217 189.08 147.259 186.561 147.259L124.991 147.259C122.472 147.259 120.43 145.217 120.43 142.698L120.43 106.212Z",
    fill: "#BFD6E8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.561 103.932L124.991 103.932C123.731 103.932 122.71 104.953 122.71 106.212L122.71 142.698C122.71 143.958 123.731 144.979 124.991 144.979L186.561 144.979C187.82 144.979 188.841 143.958 188.841 142.698L188.841 106.212C188.841 104.953 187.82 103.932 186.561 103.932ZM124.991 101.651C122.472 101.651 120.43 103.693 120.43 106.212L120.43 142.698C120.43 145.217 122.472 147.259 124.991 147.259L186.561 147.259C189.08 147.259 191.122 145.217 191.122 142.698L191.122 106.212C191.122 103.693 189.08 101.651 186.561 101.651L124.991 101.651Z",
    fill: "#002E52"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.562 113.053L122.711 113.053L122.711 103.932L186.562 103.932C189.08 103.932 191.122 105.974 191.122 108.492C191.122 111.011 189.08 113.053 186.562 113.053Z",
    fill: "#002E52"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 120.43,
    y1: 123.598,
    x2: 188.841,
    y2: 123.598,
    stroke: "#002E52",
    strokeWidth: 1.71337
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 120.43,
    y1: 135.001,
    x2: 188.841,
    y2: 135.001,
    stroke: "#002E52",
    strokeWidth: 1.71337
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M122.958 86.1951L143.086 86.1951C145.029 86.1951 146.242 84.0914 145.268 82.412L136.058 66.461L136.058 58.7633C136.727 58.6139 137.217 57.9804 137.128 57.2453C137.044 56.5401 136.387 56.0381 135.675 56.0381L130.374 56.0381C129.663 56.0381 129.006 56.5401 128.922 57.2453C128.832 57.9804 129.322 58.6139 129.992 58.7633L129.992 66.455L120.77 82.412C119.802 84.0914 121.015 86.1951 122.952 86.1951L122.958 86.1951Z",
    fill: "#FCFDFD"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M135.414 68.9434L130.63 68.9434L122.758 82.5812C122.264 83.4408 122.88 84.5152 123.875 84.5152L142.176 84.5152C143.172 84.5152 143.788 83.4408 143.293 82.5812L135.422 68.9434L135.414 68.9434Z",
    fill: "#DA629E"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.34
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M141.466 79.4355C135.7 82.5513 129.497 83.8979 122.614 83.1172C122.606 83.1172 122.599 83.1172 122.585 83.1172C122.521 83.8335 123.065 84.5139 123.86 84.5139L142.161 84.5139C143.156 84.5139 143.772 83.4395 143.278 82.58L141.459 79.4355L141.466 79.4355Z",
    fill: "#DA629E"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M132.305 67.9029C132.697 67.9029 133.016 67.5844 133.016 67.1917C133.016 66.7989 132.697 66.4805 132.305 66.4805C131.912 66.4805 131.594 66.7989 131.594 67.1917C131.594 67.5844 131.912 67.9029 132.305 67.9029Z",
    fill: "#E580B2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M134.451 63.6997C134.451 64.2376 134.014 64.6739 133.476 64.6739C132.938 64.6739 132.502 64.2376 132.502 63.6997C132.502 63.1619 132.938 62.7256 133.476 62.7256C134.014 62.7256 134.451 63.1619 134.451 63.6997Z",
    fill: "#E580B2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M130.357 80.644C131.093 80.644 131.689 80.0473 131.689 79.3113C131.689 78.5752 131.093 77.9785 130.357 77.9785C129.621 77.9785 129.024 78.5752 129.024 79.3113C129.024 80.0473 129.621 80.644 130.357 80.644Z",
    fill: "#E580B2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M132.646 74.9884C132.646 75.5442 132.198 75.9925 131.642 75.9925C131.086 75.9925 130.638 75.5442 130.638 74.9884C130.638 74.4326 131.086 73.9844 131.642 73.9844C132.198 73.9844 132.646 74.4326 132.646 74.9884Z",
    fill: "#E580B2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M137.14 78.1154C137.14 78.6712 136.691 79.1194 136.136 79.1194C135.58 79.1194 135.132 78.6712 135.132 78.1154C135.132 77.5596 135.58 77.1113 136.136 77.1113C136.691 77.1113 137.14 77.5596 137.14 78.1154Z",
    fill: "#E580B2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.327 83.4083C151.327 82.8403 151.788 82.3799 152.356 82.3799L188.842 82.3799C189.41 82.3799 189.87 82.8403 189.87 83.4083C189.87 83.9764 189.41 84.4368 188.842 84.4368L152.356 84.4368C151.788 84.4368 151.327 83.9764 151.327 83.4083Z",
    fill: "#002E52"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.327 76.5675C151.327 75.9995 151.788 75.5391 152.356 75.5391L188.842 75.5391C189.41 75.5391 189.87 75.9995 189.87 76.5675C189.87 77.1355 189.41 77.596 188.842 77.596L152.356 77.596C151.788 77.596 151.327 77.1355 151.327 76.5675Z",
    fill: "#002E52"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M179.431 69.5971C178.203 68.622 177.408 67.1011 177.414 65.4221L177.424 57.6608C177.43 57.1365 177.853 56.7261 178.362 56.722C178.887 56.7296 179.299 57.1528 179.305 57.6624L179.294 65.4237C179.286 67.3176 180.821 68.8487 182.716 68.862L183.294 68.8636C184.785 68.869 185.987 67.6585 186.003 66.1799L186.041 46.5336C186.049 45.7942 185.754 45.1027 185.235 44.5708C184.717 44.0389 184.025 43.7548 183.274 43.7594L182.307 43.7617C180.695 43.7566 179.369 45.0615 179.357 46.6875L179.36 47.1705C179.353 47.6948 178.931 48.1052 178.421 48.1093C177.897 48.1017 177.485 47.6785 177.479 47.169L177.477 46.6859C177.49 44.0261 179.657 41.8739 182.303 41.8825L183.27 41.8803C184.52 41.8862 185.666 42.3872 186.561 43.2659C187.443 44.1592 187.915 45.3275 187.924 46.5616L187.887 66.2079C187.885 68.7322 185.827 70.7782 183.301 70.7693L182.723 70.7677C181.473 70.7617 180.348 70.3254 179.446 69.6088L179.431 69.5971Z",
    fill: "#002E52"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.3964 69.5C70.7352 69.5 63.7139 76.5213 63.7139 85.1825V126.349C63.7139 135.01 70.7352 142.032 79.3964 142.032H95.0789C101.664 142.032 107.301 137.973 109.625 132.221C109.467 132.227 109.307 132.23 109.147 132.23H102.651C101.911 132.23 101.186 132.162 100.483 132.031C99.0764 133.369 97.1736 134.19 95.0789 134.19H79.3964C75.0658 134.19 71.5551 130.68 71.5551 126.349V85.1825C71.5551 80.8519 75.0658 77.3413 79.3964 77.3413H95.0789C99.4095 77.3413 102.92 80.8519 102.92 85.1825V100.165H109.147C109.695 100.165 110.234 100.202 110.761 100.275V85.1825C110.761 76.5213 103.74 69.5 95.0789 69.5H79.3964Z",
    fill: "#002E52"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_11283_121075)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.5 110.296C47.5 103.781 52.6043 98.5 58.9007 98.5H118.099C124.396 98.5 129.5 103.781 129.5 110.296V156.704C129.5 163.219 124.396 168.5 118.099 168.5H58.9007C52.6043 168.5 47.5 163.219 47.5 156.704V110.296Z",
    fill: "#E580B2"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6405 125.953C97.6405 121.558 94.1317 117.992 89.8014 117.992C85.4712 117.992 81.958 121.558 81.958 125.953C81.958 129.105 83.7813 131.807 86.4 133.094L82.5041 148.004C82.3536 148.751 82.8438 149.357 83.5921 149.357H96.0108C96.759 149.357 97.2492 148.751 97.103 148.004L93.2028 133.09C95.8216 131.802 97.6405 129.1 97.6405 125.949V125.953Z",
    fill: "#002E52"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_11283_121075",
    x: 40.6,
    y: 95.6,
    width: 95.8,
    height: 83.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.45
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11283_121075"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11283_121075",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurely);
export default __webpack_public_path__ + "static/media/Securely.ac453aedbf2ca992cc5c84028217aa03.svg";
export { ForwardRef as ReactComponent };